import type { ReactNode } from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';
type BadgeSize = 'sm' | 'md';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
}

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business ステータスバッジUI。success/warning/error/info等のバリアント対応
 * @graph-connects none
 */
export function Badge({ children, variant = 'default', size = 'md' }: BadgeProps) {
  const sizeClass = size === 'sm' ? 'badge-sm' : '';
  return <span className={`badge badge-${variant} ${sizeClass}`}>{children}</span>;
}
